import BaseService from "./geral/BaseService";
import { objetoParaQueryString } from "../utils/formatar";

const base = "NotaFiscalADE";

export default class NotaFiscalTransporteService extends BaseService {
  constructor() {
    super(base);
  }

  listarEdiNf(numeroNota, dataInicial, dataFinal) {
    let filtros = [];
    if (numeroNota) filtros.push(`numeroNota=${numeroNota}`);
    if (dataInicial) filtros.push(`dataInicial=${dataInicial}`);
    if (dataFinal) filtros.push(`dataFinal=${dataFinal}`);

    const str = filtros.reduce(
      (accumulator, currentValue) =>
        accumulator.concat(currentValue).concat("&"),
      "?"
    );

    return super.httpGet(`/${base}/ListarNotaFiscalEdiEnvio${str}`);
  }
}



// WEBPACK FOOTER //
// ./src/services/NotaFiscalTransporteService.js